<template>
    <div class="modal-overlay">
        <div class="modal-content">
            <div class="panel-title">
                <span v-if="mode === 'buy'">
                    <h3>{{ $t('features.add_investment') }}</h3>
                </span>
                <span v-if="mode === 'sell'">
                    <h3>{{ $t('features.sell_investment') }} <b>{{ this.soldStock.code }}</b></h3>
                </span>
                <span @click="closePanel"><i class="cursor-pointer ti-close right-side-toggle"></i></span>
            </div>
            <div v-if="selectedStock" class="panel-content">
                <h5>{{ selectedStock.name }}</h5>
                <div class="stock-item">
                    <div class="stock-info">
                        <span class="symbol">{{ selectedStock.code }}</span>
                    </div>
                    <div class="stock-prices">
                        <span class="floor-price">{{ selectedStock.floor | numberDisplay }}</span>
                        <span class="ceil-price">{{ selectedStock.ceil | numberDisplay }}</span>
                        <span class="price-change box-100"
                            :class="{ 'positive': selectedStock.change > 0, 'negative': selectedStock.change < 0, 'neutral': selectedStock.change === 0, 'ceil': selectedStock.price >= selectedStock.ceil, 'floor': selectedStock.price <= selectedStock.floor }">
                            <span class="price">{{ selectedStock.price | numberDisplay }}</span>
                            {{ selectedStock.change / 100 | percentDisplay }}
                        </span>
                    </div>
                </div>
                <div v-if="pmode==='simulation'">
                    <DatePicker @input="handleInput" :label="$t('vp.buy_date')" />
                </div>
                <div class="price-row">
                    <InputNumber @change="handleChange" :label="$t('common.qty')" name="quantity" :value="quantity" showButton="true"
                        :step="step_quantity" />
                    <InputNumber @change="handleChange" :label="$t('common.buy_price')" name="price" :value="price" showButton="true" :step="step_price" />
                </div>
                <div class="price-row" v-if="mode === 'buy'">
                    <span>
                        {{ $t('common.cash') }}
                    </span>
                    <span class="trans-positive">
                        {{ this.cash | moneyDisplay }}
                    </span>
                </div>
                <div v-else class="price-row">
                    <span>
                        Số lượng hiện có
                    </span>
                    <span class="trans-positive">
                        {{ this.soldStock.quantity | numberDisplay }}
                    </span>
                </div>
                <div class="price-row">
                    <span>
                        {{ $t('common.trade_value') }}
                    </span>
                    <span class="trans-negative">
                        {{ investedCapital | numberDisplay }}
                    </span>
                </div>
                <div>
                    <ul v-if="errors.length" class="no-bullets trans-negative">
                        <li v-for="(error, index) in errors" :key="index">
                            {{ error }}
                        </li>
                    </ul>
                </div>
                <div class="footer">
                    <FormButton v-if="mode === 'buy'" type="primary" inputType="submit" text="Buy"
                        :click="saveInvestment" class="btn btn-success" />
                    <FormButton v-else type="primary" inputType="submit" text="Sell" :click="saveInvestment"
                        class="btn" />
                </div>
            </div>
            <div v-else>
                <SearchStock @stockSelected="handleStockSelection" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SearchStock from '../../../components/Common/SearchStock.vue';
import FormButton from '../../../components/Form/FormButton';
import InputNumber from '../../../components/Form/InputNumber.vue';
import DatePicker from "../../../components/Common/DatePicker.vue";

export default {
    props: {
        pid: String,
        pname: String,
        cash: Number,
        mode: {
            type: String,
            default: "buy"
        },
        pmode: {
            type: String,
            default: "experiment"
        },
        soldStock: {
            'code': '',
            'name': '-',
            'price': 0,
            'ceil': 0,
            'floor': 0,
            'change': 0
        }
    },
    components: {
        SearchStock,
        FormButton,
        InputNumber,
        DatePicker
    },
    beforeMount() {
        this.selectedStock = null;
        if (this.soldStock.code) {
            this.selectedStock = {
                'code': this.soldStock.code,
                'name': this.soldStock.name,
                'price': this.soldStock.marketPrice,
                'ceil': this.soldStock.ceil,
                'floor': this.soldStock.floor,
                'change': this.soldStock.change
            }
            this.price = this.soldStock.marketPrice;
            this.quantity = this.soldStock.quantity;
            this.investedCapital = this.price * this.quantity;
        }
    },
    data() {
        return {
            price: 10000,
            quantity: 100,
            investedCapital: 0,
            step_price: 1000,
            step_quantity: 100,
            errors: [],
            selectedStock: null,
            currentStock: null,
            selectedDate: ''
        };
    },
    watch: {
        selectedDate(newDate) {
            // this.reloadPastPrice(newDate);
        }
    },
    computed: {
        ...mapGetters({
            form: "portfolio/form",
            portfolio: "portfolio/portfolio",
            investedOK: "portfolio/investedOK",
            filteredStocks: 'common/filteredStocks',
            pastPrice: 'portfolio/pastPrice'
        })
    },
    methods: {
        ...mapActions({
            searchStock: "common/searchStock",
            buyStock: 'portfolio/buyStock',
            sellStock: 'portfolio/sellStock',
            getPriceHistory: 'portfolio/getPriceHistory',
            resetPastPrice: "portfolio/resetPastPrice"
        }),
        reloadPastPrice(newDate) {
            const params = {
                'code': this.selectedStock.code,
                'date': newDate
            }
            this.getPriceHistory(params);
            if (this.pastPrice && this.pastPrice.price > 0) {
                console.log("Past: " + this.pastPrice.price);
                this.selectedStock['price'] = this.pastPrice.price;
                this.selectedStock['ceil'] = this.pastPrice.ceil;
                this.selectedStock['floor'] = this.pastPrice.floor;
                this.selectedStock['change'] = this.pastPrice.change;
                this.resetPastPrice();
            } else {
                this.selectedStock = this.currentStock;
            }
            this.price = this.selectedStock.price;
        },
        validateBuy() {
            const errorList = [];
            if (this.pmode == 'experiment' && this.investedCapital > this.cash) {
                errorList.push("Not enough cash");
            }
            this.errors = errorList;
        },
        validateSell() {
            const errorList = [];
            if (this.quantity > this.soldStock.quantity) {
                errorList.push("Exceed available quantity");
            }
            this.errors = errorList;
        },
        handleInput(value) {
            console.log("Selected" + value);
            this.selectedDate = value;
        },
        handleChange(obj) {
            if (obj.name === 'quantity') {
                this.quantity = obj.value;
                this.investedCapital = this.price * obj.value;
            } else if (obj.name === 'price') {
                this.price = obj.value;
                this.investedCapital = obj.value * this.quantity;
            }
            if (this.mode === 'buy') {
                this.validateBuy();
            } else {
                this.validateSell();
            }
        },
        handleStockSelection(stock) {
            this.selectedStock = stock;
            this.currentStock = stock;
            this.price = stock.price;
            this.investedCapital = this.price * this.quantity;
            if (this.mode === 'buy') {
                this.validateBuy();
            } else {
                this.validateSell();
            }
        },
        saveInvestment() {
            const body = {
                'code': this.selectedStock.code,
                'price': this.price,
                'quantity': this.quantity,
                'buyDate': this.selectedDate
            };
            const data = {
                'portfolioId': this.pid,
                'body': body
            }
            if (this.mode === 'buy') {
                this.validateBuy();
                if (this.errors.length === 0) {
                    this.buyStock(data);
                    this.closePanel();
                }
            } else {
                this.validateSell();
                if (this.errors.length === 0) {
                    this.sellStock(data);
                    this.closePanel();
                }
            }
        },
        closePanel() {
            this.selectedStock = null;
            this.$emit('close');
        }
    },
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    /* Ensures it appears over everything else */
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
    text-align: center;
}

.panel-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.panel-content {
    margin-top: 20px;
}

.price-row {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
}

.stock-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #ddd;
}

.stock-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.symbol {
    font-weight: bold;
}

.name {
    color: #555;
    font-size: 0.9em;
}

/* Price alignment (right side) */
.stock-prices {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}

.price {
    font-weight: bold;
}

.floor-price {
    color: var(--cyan);
}

.ceil-price {
    color: var(--purple);
}

/* Price Change color based on value */
</style>